<template>
  <div class="product">
    <h4>{{ name }}</h4>
    <slot></slot>
    <div class="product-url">
      <a :href="url" class="btn btn-primary btn-lg">{{ callToAction }}</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['name', 'url', 'callToAction'],
    name: 'Produto'
  }
</script>
